import {
  HOST_TO_COUNTRY,
  LOCALIZED_HOST_SET,
  MULTI_COUNTRY_HOSTS,
  PRIMARY_HOSTS,
} from "@constants/localizedHosts"

export type CountryCode =
  | "AE"
  | "AR"
  | "AU"
  | "BR"
  | "CA"
  | "CL"
  | "DE"
  | "ES"
  | "FR"
  | "GB"
  | "HK"
  | "ID"
  | "IN"
  | "IT"
  | "JP"
  | "MX"
  | "MY"
  | "NL"
  | "NZ"
  | "PH"
  | "SG"
  | "TH"
  | "TW"
  | "US"
  | "VN"

const resolveHostname = (explicit?: string) =>
  explicit ?? (typeof window !== "undefined" ? window.location.hostname : "")

export function resolveCartCountryCode(opts: {
  geoCountryCode?: CountryCode | null | undefined
  hostname?: string
}): { ambiguousHost: boolean; country: CountryCode } {
  const host = resolveHostname(opts.hostname).toLowerCase().split(":")[0]

  if (PRIMARY_HOSTS.has(host)) {
    return { ambiguousHost: false, country: "US" }
  }

  if (LOCALIZED_HOST_SET.has(host)) {
    const list = MULTI_COUNTRY_HOSTS[host]
    if (list && list.length > 1) {
      const geo = (opts.geoCountryCode || "").toUpperCase()
      const chosen = (list as string[]).includes(geo)
        ? (geo as CountryCode)
        : (list[0] as CountryCode)
      return { ambiguousHost: true, country: chosen }
    }
    return {
      ambiguousHost: false,
      country: (HOST_TO_COUNTRY[host] as CountryCode) || "US",
    }
  }

  // Unknown (dev/staging) — default US
  return { ambiguousHost: false, country: "US" }
}
